import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getProjectOrganizationChartItemOfActiveEmployer } from '../services/getProjectOrganizationChartItemOfActiveEmployer.service';

export const loadProjectOrganizationChartItemOfActiveEmployer =
  createAsyncThunk(
    'organizationCharts/loadProjectOrganizationChartItemOfActiveEmployer',
    async (_, { getState }) => {
      const selectedProjectId = selectSelectedProjectId(getState());

      const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

      const response = await getProjectOrganizationChartItemOfActiveEmployer(
        selectedProjectId,
        activeEmployerInfo
      );

      return response;
    }
  );
